import { Form, Input } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import PasswordRules from '../PasswordRules';
import formValidatePassword from '@/utils/functions/formValidatePassword';

const PasswordFormFields = () => {
  const intl = useIntl();
  const form = Form.useFormInstance();
  const formValues = Form.useWatch([], form);

  return (
    <>
      <Form.Item
        name="oldPassword"
        label={
          <FormattedMessage id="settings.account.accessData.oldPassword" />
        }
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'settings.account.accessData.message.password.required',
            }),
          },
          {
            min: 8,
            message: intl.formatMessage({
              id: 'settings.account.accessData.message.password.min',
            }),
          },
        ]}
        hasFeedback
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        name="newPassword"
        label={
          <FormattedMessage id="settings.account.accessData.newPassword" />
        }
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'settings.account.accessData.message.password.required',
            }),
          },
          formValidatePassword,
        ]}
        hasFeedback
      >
        <Input.Password />
      </Form.Item>

      <div style={{ marginBottom: 24 }}>
        <PasswordRules password={formValues?.newPassword} />
      </div>

      <Form.Item
        name="passwordVerify"
        label={
          <FormattedMessage id="settings.account.accessData.passwordVerify" />
        }
        dependencies={['newPassword']}
        hasFeedback
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'settings.account.accessData.message.password.required',
            }),
          },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue('newPassword') === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                intl.formatMessage({
                  id: 'settings.account.accessData.message.password.verify',
                }),
              );
            },
          }),
        ]}
      >
        <Input.Password />
      </Form.Item>
    </>
  );
};

export default PasswordFormFields;
